import { Warning } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@mui/material";

interface ConfirmCondensedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmCondensedModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmCondensedModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning color="warning" />
          Overwrite Existing Condensed Report?
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          A condensed report already exists for this survey. Generating a new
          one will overwrite the existing condensed report. This action cannot
          be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Continue & Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCondensedModal;
